import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'next-themes@0.4.6';

import '@/i18n';
import '@/index.css';

import { initUrlParams } from '@/utils/urlParams';
import { Toaster } from '@/components/ui/sonner';
import { AuthInitializer } from '@/components/AuthInitializer';
import { LoginPage } from '@/components/LoginPage';
import { SignupPage } from '@/components/SignupPage';
import App from '@/App';

initUrlParams();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: 1,
    },
  },
});

const appElement = <App />;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <BrowserRouter>
          <AuthInitializer>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/" element={<Navigate to="/cowork" replace />} />
            <Route path="/chat" element={appElement} />
            <Route path="/chat/*" element={appElement} />
            <Route path="/cowork" element={appElement} />
            <Route path="/cowork/*" element={appElement} />
            <Route path="/settings" element={appElement} />
            <Route path="/team" element={appElement} />
            <Route path="/dev-mode" element={appElement} />
            <Route path="*" element={<Navigate to="/cowork" replace />} />
          </Routes>
          </AuthInitializer>
          <Toaster />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
